// File: clientapp/src/pages/SecurityRoles.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Container, Typography, Paper, Table, TableHead, TableRow,
    TableCell, TableBody, IconButton, Tooltip, TextField, TablePagination, Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function SecurityRoles() {
    const [roles, setRoles] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    useEffect(() => {
        fetchRoles();
    }, []);

    async function fetchRoles() {
        try {
            const response = await fetch('/api/security/roles', {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                setRoles(data);
            }
        } catch (err) {
            console.error(err);
        }
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this role?")) {
            try {
                const response = await fetch(`/api/security/roles/${id}`, {
                    method: 'DELETE',
                    credentials: 'include'
                });
                if (response.ok) {
                    fetchRoles();
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredRoles = roles.filter(r => r.name.toLowerCase().includes(filterText.toLowerCase()));
    const paginatedRoles = filteredRoles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Container>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Manage Roles</Typography>
                <Tooltip title="Create New Role">
                    <IconButton color="primary" component={Link} to="/security/roles/new">
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box mb={2}>
                <TextField
                    label="Search Roles"
                    variant="outlined"
                    size="small"
                    value={filterText}
                    onChange={e => {
                        setFilterText(e.target.value);
                        setPage(0);
                    }}
                    fullWidth
                />
            </Box>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Role Name</TableCell>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Actions</TableCell>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Detail</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedRoles.map(role => (
                            <TableRow key={role.id}>
                                <TableCell>{role.name}</TableCell>
                                <TableCell>
                                    <Tooltip title="Delete Role">
                                        <IconButton size="small" onClick={() => handleDelete(role.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell>
                                    <Tooltip title="View Details / Edit">
                                        <IconButton size="small" component={Link} to={`/security/roles/${role.id}`}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={filteredRoles.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 20, 50]}
                />
            </Paper>
        </Container>
    );
}
